export enum ElementSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
